module.exports = __webpack_public_path__ + "img/f1@2x.c533ae91.png";